// extracted by mini-css-extract-plugin
export default {"wrap":"Pagination_wrap__waAy2","btn":"Pagination_btn__B3NM9","info":"Pagination_info__iNBjt"};